import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/pwHand.png'


const _withScopeId = n => (_pushScopeId("data-v-60f597b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "id_result" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "비밀번호를 잊어버리셨나요?", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "body" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "아이디 찾기 조회결과", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "귀하의 아이디 입니다.", -1))
const _hoisted_8 = { class: "result" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "pwFindBox",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.pwPageMove()))
    }, _hoisted_4),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _hoisted_7,
      _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.userid), 1)
    ]),
    _createElementVNode("div", {
      class: "btn",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loginPageMove()))
    }, "로그인 하기")
  ]))
}